function waitForOneTrust() {
    hasOneTrustLoaded();
    let attempts = 0;
    const interval = setInterval(function () {
        if (hasOneTrustLoaded() || attempts > 100) {
            clearInterval(interval);
        }
        attempts++;
    }, 100)
}

function hasOneTrustLoaded() {
    if (typeof window.OnetrustActiveGroups === 'string') {
        //check now
        optanonWrapper()
        // and wrap and trigger after cookie opt-in
        window.OptanonWrapper = optanonWrapper;
        return true;

    }
    return false;
}

function sendConsent(trackingConsent) {
    console.log(trackingConsent)
    window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent, () => {
        console.log("Shopify Consent Captured")
        //To reload a page once consent is updated by the user
        document.querySelectorAll('.save-preference-btn-handler.onetrust-close-btn-handler, #onetrust-accept-btn-handler, #onetrust-reject-all-handler, #accept-recommended-btn-handler').forEach(el => {
            el.addEventListener('click', function () {
                window.location.reload();
            });
        });
    });
}

function youtubeConsent(iframe) {

    // Get all elements with the specified class
    const consentiframes = document.getElementsByClassName('consent-iframe1');
    // Remove each iframe element
    while (consentiframes.length > 0) {
        consentiframes[0].parentNode.removeChild(consentiframes[0]);
    }

    // Get all elements with the specified class
    var consentElements = document.getElementsByClassName('consent-video-btn');
    // Check if any elements were found
    while (consentElements.length > 0) {
        // Remove the first element with the specified class
        consentElements[0].remove();
    }

    // Get the div elements by their class name
    const consentDivs = document.getElementsByClassName('consent-thumb');
    // Loop through the divs and set their display property to "block"
    for (let i = 0; i < consentDivs.length; i++) {
        consentDivs[i].style.display = 'block';
    }

}

function optanonWrapper() {
    performanceConsent = !!window.OnetrustActiveGroups.includes('C0002');
    functionalConsent = !!window.OnetrustActiveGroups.includes('C0003');
    targetingConsent = !!window.OnetrustActiveGroups.includes('C0004');
    const trackingConsent = { analytics: performanceConsent, marketing: targetingConsent, preferences: functionalConsent, sale_of_data: false };

    window.Shopify.loadFeatures(
        [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ],
        error => {
            if (error) {
                throw error;
            }
            sendConsent(trackingConsent)
        },
    );
    if (!window.OnetrustActiveGroups.includes('C0002') || !window.OnetrustActiveGroups.includes('C0003') || !window.OnetrustActiveGroups.includes('C0004') || !window.OnetrustActiveGroups.includes('C0005')) {
        let iframes = document.getElementsByTagName("iframe");
        for (var i = 0; i < iframes.length; i++) {
            let src = iframes[i].getAttribute('data-src');
            if (src && src.includes("www.youtube.com")) {
                youtubeConsent(iframes[i]);
            }
        }
    }
}

(function () {
    // Loop through the divs and set their display property to "none"
    // Get the div elements by their class name
    const consentDiv = document.getElementsByClassName('consent-thumb');
    for (let i = 0; i < consentDiv.length; i++) {
        consentDiv[i].style.display = 'none';
    }

    waitForOneTrust();
})();